import axios from 'axios'
import getEnv from '../lib/get-env.js'

export const getAccountIdentityAssignments = async ({
  bearerToken,
  accountUserId,
}) => {
  const identityAssignmentsResponse = await axios.get(
    `${getEnv(
      'REACT_APP_ACCOUNT_URL'
    )}/v1/users/${accountUserId}/identity-assignments`,
    {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    }
  )
  const identityAssignments = identityAssignmentsResponse.data

  return identityAssignments
}

export const getAccountIdentityAssignment = async ({
  bearerToken,
  accountUserId,
  authVendorUserId,
  identityTypeId,
}) => {
  const identityAssignments = await getAccountIdentityAssignments({
    bearerToken,
    accountUserId,
  })

  const identityAssignment = identityAssignments.find(
    (x) =>
      x.identityTypeId === identityTypeId &&
      x.authVendorUserId === authVendorUserId
  )

  return identityAssignment
}
